export interface GetPartnersWsV2ResponseSuccess {
  status: 'OK';
  response: {
    code: '200';
    message: 'Confirmed';
  };
  data: GetPartnersWsV2Response;
}

export interface GetPartnersWsV2ResponseError {
  status: 'ERROR';
  response: {
    code: string;
    message: string;
  };
}

export interface GetPartnersWsV2Response {
  partnerDetails: PartnersDetailsV2[];
}

export interface PartnersDetailsV2 {
  partnerID: string;
  partnerName: string;
  address: PartnersDetailsAddressV2;
  location: PartnersDetailsLocationV2;
  contact: PartnersDetailsContactV2;
  insurerInternalID?: string;
  opening?: PartnersDetailsOpeningV2;
  specificHours?: PartnersDetailsSpecificHoursV2;
}

export interface PartnersDetailsAddressV2 {
  address: string;
  postalCode: string;
  city: string;
}

export interface PartnersDetailsLocationV2 {
  long: string;
  lat: string;
}

export interface PartnersDetailsContactV2 {
  phone: string;
  mail: string;
}

export interface PartnersDetailsOpeningV2 {
  periods?: PartnersDetailsOpeningPeriodsV2[];
}

export interface PartnersDetailsOpeningPeriodsV2 {
  close: PartnersDetailsOpeningPeriodDayTimeV2;
  open: PartnersDetailsOpeningPeriodDayTimeV2;
}

export interface PartnersDetailsOpeningPeriodDayTimeV2 {
  day: number;
  time: string;
}

export interface PartnersDetailsSpecificHoursV2 {
  open?: PartnersDetailsSpecificHoursPeriodsV2[];
  close?: PartnersDetailsSpecificHoursPeriodsV2[];
}

export interface PartnersDetailsSpecificHoursPeriodsV2 {
  reason: string;
  startDate: string; // DD/MM/YYYY
  startTime: string; // HH:mm
  endDate: string; // DD/MM/YYYY
  endTime: string; // HH:mm
  allDay: boolean;
}
